'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsInputHdmi = function MdSettingsInputHdmi(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.4 6.6v5h3.2v-3.2h1.8v3.2h3.2v-3.2h1.8v3.2h3.2v-5h-13.2z m16.6 5h1.6v10l-5 10v5h-13.2v-5l-5-10v-10h1.6v-5q0-1.3 1-2.3t2.4-0.9h13.2q1.4 0 2.4 0.9t1 2.3v5z' })
        )
    );
};

exports.default = MdSettingsInputHdmi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-input-hdmi.js
// module id = 3766
// module chunks = 168707334958949